import { call, put, takeEvery } from 'redux-saga/effects'

import { types } from '../../types'

import {
    getCallReportSettings, getCustomerLineServices, getCustomerMembers,
    getGeneralLineSettings, getLineFaxSettings,
    getLineSeparationSettings,
    getLineVoicemailSettings, getPasswordStatus, postUploadmusicOnHoldRequest, setCallReportSettings, setGeneralLineSettings, setLineFaxSettings, setLineVoicemailSettings, setPassword, setPasswordStatus
} from '../apiRequests/lineSettingsRequest'
import { CustomerMember } from '../../interfaces/customer'




function* handleGetGeneralLineSettingsRequest(action) {
    try {
        const response = yield call(getGeneralLineSettings, action.params)

        const _response = {
            data: {

                CustomerLineId: response.data.customerLineId,
                Enabled: response.data.enabled,
                Title: response.data.title,
                LineServiceType: response.data.lineServiceType,
                Color: response.data.color,
                PurchasedWithProductType: response.data.purchasedWithProductType,
                Number: response.data.number,
                IsInSeparationTime: response.data.isInSeparationTime,
                VoicemailEnabled: response.data.voicemailEnabled,
                FaxEnabled: response.data.faxEnabled,
                OutgoingCallEnabled: response.data.cutgoingCallEnabled,
                CallRecordingEnable: response.data.callRecordingEnable,
                CallRecordingAbility: response.data.callRecordingAbility,
                Id: response.data.id,
                Errors: response.data.errors,
                Confirms: response.data.confirms,
                Delete: response.data.delete,
                PageIndex: response.data.pageIndex,
                PageSize: response.data.pageSize

            }
        }
        yield put({
            type: types.GET_GENERAL_LINE_SETTINGS_SUCCESS,
            action: _response,
        })
    } catch (error) {
        yield put({
            type: types.GET_GENERAL_LINE_SETTINGS_ERROR,
            error: error.response,
        })
    }
}


function* handleGetCustomerLineServicesRequest(action) {
    try {
        const response = yield call(getCustomerLineServices, action.params)
        yield put({
            type: types.GET_CUSTOMER_LINE_SERVICES_SUCCESS,
            action: response,
        })
    } catch (error) {
        yield put({
            type: types.GET_CUSTOMER_LINE_SERVICES_ERROR,
            error: error.response,
        })
    }
}

function* handleGetCallReportSettingsRequest(action) {
    try {
        const response = yield call(getCallReportSettings, action.params)
        yield put({
            type: types.GET_CALL_REPORT_SETTINGS_SUCCESS,
            action: response,
        })
    } catch (error) {
        yield put({
            type: types.GET_CALL_REPORT_SETTINGS_ERROR,
            error: error.response,
        })
    }
}

function* handleGetLineFaxSettingsRequest(action) {
    try {
        const response = yield call(getLineFaxSettings, action.params)
        yield put({
            type: types.GET_LINE_FAX_SETTINGS_SUCCESS,
            action: response,
        })
    } catch (error) {
        yield put({
            type: types.GET_LINE_FAX_SETTINGS_ERROR,
            error: error.response,
        })
    }
}

function* handleGetLineVoicemailSettingsRequest(action) {
    try {

        const response = yield call(getLineVoicemailSettings, action.params)
        yield put({
            type: types.GET_LINE_VOICEMAIL_SETTINGS_SUCCESS,
            action: response,
        })
    } catch (error) {
        yield put({
            type: types.GET_LINE_VOICEMAIL_SETTINGS_ERROR,
            error: error.response,
        })
    }
}
function* handleGetCustomerMembersRequest() {
    try {
        const response = yield call(getCustomerMembers)
        const customerMember = new CustomerMember()
        customerMember.mapper(response.data)
        yield put({
            type: types.GET_CUSTOMER_MEMBERS_SUCCESS,
            action: { data: customerMember },
        })
    } catch (error) {
        yield put({
            type: types.GET_CUSTOMER_MEMBERS_ERROR,
            error: error.response,
        })
    }
}
function* handleGetPasswordStatusRequest(action) {
    try {
        const response = yield call(getPasswordStatus, action.params)
        yield put({
            type: types.GET_PASSWORD_STATUS_SUCCESS,
            action: response,
        })
    } catch (error) {
        yield put({
            type: types.GET_PASSWORD_STATUS_ERROR,
            error: error.response,
        })
    }
}

function* handleSetGeneralLineSettingsRequest(action) {
    try {

        const response = yield call(setGeneralLineSettings, action.params)
        yield put({
            type: types.SET_GENERAL_LINE_SETTINGS_SUCCESS,
            action: response,
        })
    } catch (error) {
        yield put({
            type: types.SET_GENERAL_LINE_SETTINGS_ERROR,
            error: error.response,
        })
    }
}

function* handleSetCallReportSettingsRequest(action) {
    try {

        const response = yield call(setCallReportSettings, action.params)
        yield put({
            type: types.SET_CALL_REPORT_SETTINGS_SUCCESS,
            action: response,
        })
    } catch (error) {
        yield put({
            type: types.SET_CALL_REPORT_SETTINGS_ERROR,
            error: error.response,
        })
    }
}
function* handleSetLineFaxSettingsRequest(action) {
    try {

        const response = yield call(setLineFaxSettings, action.params)
        yield put({
            type: types.SET_LINE_FAX_SETTINGS_SUCCESS,
            action: response,
        })
    } catch (error) {
        yield put({
            type: types.SET_LINE_FAX_SETTINGS_ERROR,
            error: error.response,
        })
    }
}

function* handleSetLineVoicemailSettingsRequest(action) {
    try {

        const response = yield call(setLineVoicemailSettings, action.params)
        yield put({
            type: types.SET_LINE_VOICEMAIL_SETTINGS_SUCCESS,
            action: response,
        })
    } catch (error) {
        yield put({
            type: types.SET_LINE_VOICEMAIL_SETTINGS_ERROR,
            error: error.response,
        })
    }
}

function* handleSetLinePasswordStatusSettingsRequest(action) {
    try {

        const response = yield call(setPasswordStatus, action.params)
        yield put({
            type: types.SET_PASSWORD_STATUS_SUCCESS,
            action: response,
        })
    } catch (error) {
        yield put({
            type: types.SET_PASSWORD_STATUS_ERROR,
            error: error.response,
        })
    }
}
function* handleSetLineOutgoingCallPasswordRequest(action) {
    try {

        const response = yield call(setPassword, action.params)
        yield put({
            type: types.SET_PASSWORD_SETTING_SUCCESS,
            action: response,
        })
    } catch (error) {
        yield put({
            type: types.SET_PASSWORD_SETTING_ERROR,
            error: error.response,
        })
    }
}

function* handleGetLineSeparationSettingsRequest(action) {
    try {

        const response = yield call(getLineSeparationSettings, action.params)
        yield put({
            type: types.GET_LINE_SEPARATION_SETTING_SUCCESS,
            action: response,
        })
    } catch (error) {
        yield put({
            type: types.GET_LINE_SEPARATION_SETTING_ERROR,
            error: error.response,
        })
    }
}


function* handleUploadMusicOnHoldRequest(action) {
    try {

        const response = yield call(postUploadmusicOnHoldRequest, action.params)
        yield put({
            type: types.POST_UPLOAD_MUSIC_ON_HOLD_SUCCESS,
            action: response,
        })
    } catch (error) {
        yield put({
            type: types.POST_UPLOAD_MUSIC_ON_HOLD_ERROR,
            error: error.response,
        })
    }
}


function* watcherLineSettingsSaga() {
    yield takeEvery(types.GET_GENERAL_LINE_SETTINGS_REQUEST, handleGetGeneralLineSettingsRequest)
    yield takeEvery(types.GET_CUSTOMER_LINE_SERVICES_REQUEST, handleGetCustomerLineServicesRequest)
    yield takeEvery(types.GET_CALL_REPORT_SETTINGS_REQUEST, handleGetCallReportSettingsRequest)
    yield takeEvery(types.GET_LINE_FAX_SETTINGS_REQUEST, handleGetLineFaxSettingsRequest)
    yield takeEvery(types.GET_LINE_VOICEMAIL_SETTINGS_REQUEST, handleGetLineVoicemailSettingsRequest)
    yield takeEvery(types.GET_CUSTOMER_MEMBERS_REQUEST, handleGetCustomerMembersRequest)
    yield takeEvery(types.GET_PASSWORD_STATUS_REQUEST, handleGetPasswordStatusRequest)
    yield takeEvery(types.SET_GENERAL_LINE_SETTINGS_REQUEST, handleSetGeneralLineSettingsRequest)
    yield takeEvery(types.SET_CALL_REPORT_SETTINGS_REQUEST, handleSetCallReportSettingsRequest)
    yield takeEvery(types.SET_LINE_FAX_SETTINGS_REQUEST, handleSetLineFaxSettingsRequest)
    yield takeEvery(types.SET_LINE_VOICEMAIL_SETTINGS_REQUEST, handleSetLineVoicemailSettingsRequest)
    yield takeEvery(types.SET_PASSWORD_STATUS_REQUEST, handleSetLinePasswordStatusSettingsRequest)
    yield takeEvery(types.SET_PASSWORD_SETTING_REQUEST, handleSetLineOutgoingCallPasswordRequest)
    yield takeEvery(types.GET_LINE_SEPARATION_SETTING_REQUEST, handleGetLineSeparationSettingsRequest)
    yield takeEvery(types.POST_UPLOAD_MUSIC_ON_HOLD_REQUEST, handleUploadMusicOnHoldRequest)







}

export default watcherLineSettingsSaga
